import { constants } from "../../../constants";

export default class UrlChanged {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default(data) {
        this.gb.emitters.emit.web.urlChanged(data);
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.DUSO:
                event["URL_CHANGED"] = this._default;
                break;
            default:
                event["urlChanged"] = this._default;
        }

        return event;
    }
}